import { keyframes } from '@emotion/react';
import { alpha, Box, List, ListItemButton, styled, Typography } from '@mui/material';
import { ElementType } from 'react';

const domainSidebarReveal = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const DomainSidebarContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  minWidth: 0,
  padding: '16px 4px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  animation: `${domainSidebarReveal} 260ms ease-out both`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
}));

export const DomainSidebarTitle = styled(Typography)(({ theme }) => ({
  padding: '0 20px 14px',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  color: theme.palette.secondary.main,
}));

export const DomainSidebarList = styled(List)({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

export const DomainSidebarItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive?: boolean; component?: ElementType; to?: string }>(({ theme, isActive }) => ({
  height: '40px',
  padding: '0 20px',
  minWidth: 0,
  background: isActive ? alpha(theme.palette.info.main, 0.5) : 'transparent',
  '&.Mui-selected, &.Mui-selected:hover': {
    background: alpha(theme.palette.info.main, 0.5),
  },
  '&:hover': {
    background: isActive ? alpha(theme.palette.info.main, 0.5) : theme.palette.info.light,
  },
  '.MuiListItemText-root': {
    margin: 0,
  },
  '.MuiTypography-root': {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
    color: isActive ? theme.palette.primary.main : theme.palette.secondary.main,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));
